import { Component, Input, Output, EventEmitter } from '@angular/core';

interface CardTotal {
  simbolo: string;
  valor: number;
  label: string;
  moeda: string;
  flagUrl: string;
  corBorda: string;
}

@Component({
  selector: 'app-resumo-totais',
  templateUrl: './resumo-totais.component.html',
  styleUrls: ['./resumo-totais.component.scss'],
})
export class ResumoTotaisComponent {

  @Input() cardsTotais: CardTotal[] = [];
  @Input() loading = false;
  @Input() filtroMoedaSelecionada: string | null = null;

  @Output() moedaClicada = new EventEmitter<string>();

  onMoedaClick(moeda: string): void {
    this.moedaClicada.emit(moeda);
  }

  /**
   * Formata um valor monetario de acordo com a moeda do card
   * (GUARANI/REAL/DOLAR/PESO). Replica o padrao de formatarValorMonetario
   * da tela de Movimentacao.
   */
  formatarValor(valor: number | null | undefined, moeda: string): string {
    if (valor == null || isNaN(valor as number)) return '-';
    const moedaStr = (moeda || '').toUpperCase();
    const configuracoes: Record<string, { locale: string; simbolo: string; decimais: boolean }> = {
      GUARANI: { locale: 'es-PY', simbolo: 'Gs', decimais: false },
      REAL: { locale: 'pt-BR', simbolo: 'R$', decimais: true },
      DOLAR: { locale: 'en-US', simbolo: '$', decimais: true },
      PESO: { locale: 'es-AR', simbolo: '$', decimais: true },
    };
    const config = configuracoes[moedaStr] ?? configuracoes['GUARANI'];
    const options: Intl.NumberFormatOptions = config.decimais
      ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      : { minimumFractionDigits: 0, maximumFractionDigits: 0 };
    const valorFormatado = new Intl.NumberFormat(config.locale, options).format(Math.abs(valor as number));
    return `${config.simbolo} ${valorFormatado}`;
  }
}
